import { Horizontal } from "Components/Horizontal";
import { StateSelectDropdown } from "Inputs/StateSelectDropdown";
import { Textbox } from "Inputs/Textbox";
import { getZipCodeValidator, YupDefined } from "Inputs/Tools";
import React from "react";
import * as Yup from "yup";
import { SubscriptableFieldProps } from "./FormTools";

export interface AddressInputFormValues {
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  zipCode: string | null;
}

export function AddressInput(props: {
  field: SubscriptableFieldProps<AddressInputFormValues>;
  isRequired?: true;
  label?: React.ReactNode;
}) {
  return (
    <>
      <Horizontal
        isRequired={props.isRequired}
        label={props.label ?? "Address"}
      >
        <div className="field">
          <Textbox
            fieldProps={props.field.address1}
            placeholder="Address 1"
            inputProps={{ autoComplete: "address-line1" }}
          />
        </div>
      </Horizontal>
      <Horizontal>
        <div className="field">
          <Textbox
            fieldProps={props.field.address2}
            placeholder="Address 2"
            inputProps={{ autoComplete: "address-line2" }}
          />
        </div>
      </Horizontal>
      <Horizontal>
        <div className="field" style={{ flexBasis: 0 }}>
          <Textbox
            fieldProps={props.field.city}
            placeholder="City"
            inputProps={{ autoComplete: "address-level2" }}
          />
        </div>
        <div className="field" style={{ flexBasis: 0 }}>
          <StateSelectDropdown field={props.field.state} />
        </div>
        <div className="field" style={{ flexBasis: 0 }}>
          <Textbox
            type="tel"
            fieldProps={props.field.zipCode}
            placeholder="Zip Code"
            inputProps={{ autoComplete: "postal-code" }}
          />
        </div>
      </Horizontal>
    </>
  );
}

AddressInput.getDefaultValidator = (labelPrefix = "") =>
  Yup.object({
    address1: YupDefined.string()
      .nullable()
      .max(255)
      .label(`${labelPrefix}Address 1`)
      .required(),
    address2: YupDefined.string()
      .nullable()
      .max(255)
      .label(`${labelPrefix}Address 2`),
    city: YupDefined.string()
      .nullable()
      .max(255)
      .label(`${labelPrefix}City`)
      .required(),
    state: YupDefined.string()
      .nullable()
      .max(255)
      .label(`${labelPrefix}State`)
      .required(),
    zipCode: getZipCodeValidator().label(`${labelPrefix}Zip Code`).required(),
  });
